import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

export function Toaster({ ...props }: ToasterProps) {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-brand-primary group-[.toaster]:border-brand-primary/20 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-brand-primary/70",
          actionButton:
            "group-[.toast]:bg-[#967F81] group-[.toast]:text-white group-[.toast]:font-medium group-[.toast]:px-4 group-[.toast]:py-2 group-[.toast]:rounded-md group-[.toast]:hover:bg-[#843329]",
          cancelButton:
            "group-[.toast]:bg-[#967F81]/10 group-[.toast]:text-brand-primary",
          success: 
            "group-[.toast]:!bg-white group-[.toast]:border-brand-primary/20 group-[.toast]:text-brand-primary",
          info: 
            "group-[.toast]:!bg-white group-[.toast]:border-brand-primary/20 group-[.toast]:text-brand-primary",
          warning: 
            "group-[.toast]:!bg-white group-[.toast]:border-brand-primary/20 group-[.toast]:text-brand-primary",
          error: 
            "group-[.toast]:!bg-white group-[.toast]:border-brand-primary/20 group-[.toast]:text-brand-primary",
          // Orange check icon container for success
          successIcon: 
            "group-[.toast]:!bg-[#967F81] group-[.toast]:text-white",
          // Main text color
          title:
            "group-[.toast]:text-brand-primary",
          // Success icon - ensure it's orange
          successIconSVG:
            "group-[.toast]:fill-[brand-primary] group-[.toast]:text-brand-primary"
        },
      }}
      {...props}
    />
  )
}
